var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "phone-verification"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputPhoneNumber,
      expression: "inputPhoneNumber"
    }],
    staticClass: "field__input flex-fill google-sans-code",
    class: {
      invalid: _vm.validationError || _vm.shouldDisplayNotVerifiedMessage
    },
    attrs: {
      "type": "tel",
      "placeholder": _vm.placeholder,
      "disabled": false === _vm.changingPhoneNumberIsAvailable
    },
    domProps: {
      "value": _vm.inputPhoneNumber
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.inputPhoneNumber = $event.target.value;
      }, function ($event) {
        return _vm.$emit('input', _vm.inputPhoneNumber);
      }]
    }
  }), _vm.currentPhoneNumberIsVerified ? _c('SharedButton', {
    staticClass: "phone-verification__send-sms ml-3 w-auto text-nowrap s-btn-bg-primary",
    attrs: {
      "disabled": true
    }
  }, [_vm._v(" " + _vm._s(_vm.trans('mobile_verified', '已驗證')) + " ")]) : _c('SharedButton', {
    staticClass: "phone-verification__send-sms ml-3 w-auto text-nowrap s-btn-bg-primary",
    attrs: {
      "disabled": false === _vm.sendingCodeIsAvailable
    },
    on: {
      "click": _vm.sendMobile
    }
  }, [_vm.sendingCodeIsAvailable ? [_vm._v(_vm._s(_vm.trans('send_sms_code', '傳送驗證碼')))] : _vm.verificationCodeIsThrottled ? [_vm._v(_vm._s(_vm.counterMessage))] : _vm.isEditingPhoneNumber && _vm.isSendingVerificationCode ? [_vm._v("傳送中...")] : _vm._e()], 2), _vm.showEditButton ? _c('button', {
    staticClass: "btn btn-link text-nowrap ml-3",
    on: {
      "click": _vm.enableEdit
    }
  }, [_vm._v(" " + _vm._s(_vm.trans('revise', '修改')) + " ")]) : _vm._e(), _vm.showCancelButton ? _c('button', {
    staticClass: "btn btn-link text-nowrap ml-3",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" " + _vm._s(_vm.trans('cancel', '取消')) + " ")]) : _vm._e()], 1), _vm.fieldMemo ? _c('small', {
    staticClass: "field__desc"
  }, [_vm._v(_vm._s(_vm.fieldMemo))]) : _vm._e(), _vm.mobileValidationMessage ? _c('div', {
    staticClass: "phone-verification__error-message"
  }, [_vm._v(_vm._s(_vm.mobileValidationMessage))]) : _vm._e(), _vm.shouldDisplayNotVerifiedMessage ? _c('div', {
    staticClass: "phone-verification__error-message"
  }, [_vm._v(" " + _vm._s(_vm.trans('not_verify_phone_number', '手機號碼未驗証')) + " ")]) : _vm._e(), _vm.isWaitingForCodeSubmission ? _c('div', {
    staticClass: "phone-verification__code-submission my-3"
  }, [_c('div', {
    staticClass: "flex-fill"
  }, [_c('CodeInput', {
    class: {
      invalid: !_vm.codeIsValid
    },
    attrs: {
      "loading": false,
      "fields": 6,
      "fieldWidth": "100%",
      "fieldHeight": 50,
      "disabled": _vm.isSubmittingSms
    },
    on: {
      "change": _vm.handleCodeChange
    }
  }), !_vm.codeIsValid ? _c('div', {
    staticClass: "phone-verification__error-message"
  }, [_vm._v(_vm._s(_vm.codeValidationMessage))]) : _vm._e()], 1), _c('div', {
    staticClass: "flex-fill"
  }, [_c('SharedButton', {
    staticClass: "phone-verification__submit-code text-nowrap s-btn-bg-primary",
    attrs: {
      "disabled": _vm.verificationCode.length != 6 || _vm.isSubmittingSms
    },
    on: {
      "click": _vm.verifyMobile
    }
  }, [_vm._v(" " + _vm._s(_vm.isSubmittingSms ? '驗證中...' : _vm.trans('confirm', '確定')) + " ")])], 1)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }